/**
 * 첨부파일 카드 그리드 — 레거시 `approval_attachment_list_panel` CSS 1:1 매핑.
 * 추정 금지. 사용자 제공 CSS 그대로 옮김.
 */
import { keyframes, styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// .attachment-item-list
export const ListRoot = styled(Box)({
  marginTop: 5,
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: 16,
});

export const Empty = styled(Box)({
  width: '100%',
  padding: '20px 0',
  textAlign: 'center',
  color: 'var(--dk-text-dim, #B7BBC2)',
  fontSize: 13,
  lineHeight: '18px',
});

// .attachment-item-list li
export const ItemCard = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'clickable',
})<{ clickable?: boolean }>(({ clickable }) => ({
  position: 'relative',
  marginTop: 16,
  borderRadius: 8,
  width: 152,
  boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.08)',
  backgroundColor: 'var(--dk-bg, #FFFFFF)',
  overflow: 'visible',
  cursor: clickable ? 'pointer' : 'default',
  '@media screen and (max-width: 400px)': {
    width: 'calc(50% - 8px)',
  },
}));

// .attachment-item-list .attachment-item-preview
export const Thumbnail = styled(Box)({
  padding: '14px 0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
  height: 76,
  overflow: 'hidden',
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  '&.is-uploading': { position: 'relative' },
  '&.is-uploading::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background: 'rgba(255,255,255,0.7)',
  },
  '& > img': {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
});

// 업로드 중(레거시 .attachment-item.uploading) — 미리보기 위 흰 막 + 가운데 스피너
const uploadingSpin = keyframes({
  from: { transform: 'rotate(0deg)' },
  to: { transform: 'rotate(360deg)' },
});

export const UploadingSpinner = styled('span')({
  position: 'absolute',
  zIndex: 1,
  width: 20,
  height: 20,
  boxSizing: 'border-box',
  borderRadius: '50%',
  border: '2px solid #DDDDDD',
  borderTopColor: '#686868',
  animation: `${uploadingSpin} 1s linear infinite`,
});

// 파일 종류 아이콘 (svg). object-fit contain 영향 받음 — img 셀렉터 공유.
export const FileIcon = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
  display: 'block',
});

// .attachment-item-list .attachment-item-detail
export const InfoBlock = styled(Box)({
  padding: 8,
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
});

// .attachment-item-list .attachment-item-name
export const FileName = styled(Typography)({
  fontSize: 13,
  fontWeight: 500,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

// .attachment-item-list .attachment-item-info small
export const FileMeta = styled(Typography)({
  display: 'block',
  color: 'var(--dk-text-secondary, #888D96)',
  fontSize: 12,
});

/**
 * .btn-attachment-item-delete
 * 레거시는 inline SVG (close-circle) 에 `--bg-color: #4D5157` 변수 적용.
 * 우리는 button 자체 background 가 검은 원 역할 + 안에 close.svg(X 십자) 흰색 invert.
 */
export const DeleteButton = styled('button')({
  zIndex: 1,
  cursor: 'pointer',
  padding: 0,
  margin: 0,
  border: 0,
  position: 'absolute',
  top: -8,
  right: -8,
  width: 20,
  height: 20,
  borderRadius: '50%',
  boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.16)',
  backgroundColor: '#4D5157',
  color: '#FFFFFF',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& > img': {
    width: 10,
    height: 10,
    display: 'block',
    filter: 'brightness(0) invert(1)',
  },
  '&:hover': {
    backgroundColor: '#34383D',
  },
  '&:focus-visible': {
    outline: '2px solid var(--dk-accent, #0066CC)',
    outlineOffset: 2,
  },
});
